import { useMatch } from 'react-router';
import {
  ROUTE_CONTRIBUTION_DETAIL_IRA_ACCOUNT,
  ROUTE_CONTRIBUTION_DETAIL_IRA_USER,
} from 'constants/routes';
import IndependentIraInfo from 'screens/IndependentIra/IndependentIraInfo/IndependentIraInfo';
import IraUserInfo from 'screens/IraUsers/IraUserInfo/IraUserInfo';

const ContributionDetailUser = (): JSX.Element => {
  const isIRAUser = useMatch(ROUTE_CONTRIBUTION_DETAIL_IRA_USER);
  const isIRAAccount = useMatch(ROUTE_CONTRIBUTION_DETAIL_IRA_ACCOUNT);

  if (isIRAUser) {
    return <IraUserInfo />;
  }
  if (isIRAAccount) {
    return <IndependentIraInfo />;
  }
  return <></>;
};

export default ContributionDetailUser;
